import { fromJS } from 'immutable';

export default {
    setProducts: (state, products) => {
        return state.setIn(['list'], fromJS(products)).set('initialized', true);
    },
    updateProducts: (state, products) => {
        return state.mergeDeepIn(['list'], fromJS(products));
    },
    setProductDetails: (state, product) => {
        return state.mergeIn(['list'], fromJS(product));
    },
    setNewProductDetails: (state, product) => {
        return state.mergeIn(['list'], fromJS(product));
    },
    setProductStatus: (state, productKey, status) => {
        return state.setIn(['list', productKey, 'status'], status);
    },
    updateProductField: (state, productKey, fieldName, fieldValue) => {
        return state.setIn(['list', productKey, fieldName], fieldValue);
    },
    dissociateProduct: (state, productKey, fieldName, fieldValue) => {
        return state.setIn(['list', productKey, fieldName], fieldValue);
    },
    updateProductModule: (state, productKey, productModuleKey, form) => {
        return state.mergeIn(['list', productKey, 'productModules', productModuleKey], form);
    },
    updateFheProductThreshold: (state, productKey, productModuleKey, threshold) => {
        return state.setIn(['list', productKey, 'productModules', productModuleKey, 'threshold'], threshold);
    },
    updateFheProductGain: (state, productKey, productModuleKey, gain) => {
        return state.setIn(['list', productKey, 'productModules', productModuleKey, 'value'], gain);
    },
    updateFheProductPolarity: (state, productKey, productModuleKey, polarity) => {
        return state.setIn(['list', productKey, 'productModules', productModuleKey, 'reversePolarity'], polarity);
    },
    deleteProduct: (state, productKey) => {
        return state.deleteIn(['list', productKey]);
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Products/core.js